import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

const baseRoute = '/users';

@Injectable({
  providedIn: 'root'
})
export class UserService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }
}
